import { FC } from 'react';
import PayRunsList from 'containers/accounting/pay-runs/PayRunsList';
import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';

const PayRunsListPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);

  if (isActionsBlocked) {
    return <MerchantOrTeamBlockedInfo title="Pay Runs" />;
  }

  return <PayRunsList />;
};

export default PayRunsListPage;
